import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Card, DataTable } from '@w7/ui'
import { bookmakerApi, bmErrorMessage, unwrapBmList } from '@/api/bookmaker'
import { BmPage } from './BmPage'

export function HorseListPage() {
  const navigate = useNavigate()
  const [rows, setRows] = useState<Record<string, unknown>[]>([])
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function load() {
    setBusy(true)
    setError(null)
    try {
      const data = await bookmakerApi.horseList({})
      setRows(unwrapBmList(data))
    } catch (e) {
      setError(bmErrorMessage(e))
    } finally {
      setBusy(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  return (
    <BmPage
      title="Horses"
      description="Lab Horse list"
      error={error}
      actions={
        <>
          <Button onClick={() => void load()} disabled={busy}>
            Refresh
          </Button>
          <Button onClick={() => navigate('/createhorse')}>Create</Button>
        </>
      }
    >
      <Card>
        <DataTable
          label="Results"
          columns={[
            { id: 'id', header: 'Id', cell: (r: Record<string, unknown>) => String(r._id ?? r.betfairId ?? r.id ?? '—') },
            { id: 'name', header: 'Name', cell: (r: Record<string, unknown>) => String(r.name ?? r.eventName ?? r.competitionName ?? r.marketName ?? '—') },
            { id: 'status', header: 'Status', cell: (r: Record<string, unknown>) => String(r.status ?? r.enable ?? '—') },
          ]}
          rows={rows}
          loading={busy}
          rowKey={(r) => String(r._id ?? r.betfairId ?? r.id ?? Math.random())}
          onRowClick={(r) => {
            const id = String(r._id ?? r.betfairId ?? r.id ?? '')
            if (id) navigate('/edithorse/' + id)
          }}
        />
      </Card>
    </BmPage>
  )
}
